import { LinkedinProjectTypes } from 'enums';
import { Assessment } from 'types/analysis-result.types';
import { ProfileValues } from 'types/profile.types';

export interface LinkedinProject {
  id: string;
  name: string;
  linkedinContacts: { contact?: string; isAnalyzed: boolean; url: string }[];
  analysisStarted: boolean;
  analysisFinished?: boolean;
  expiresOn: string;
  status: boolean; // is the project usable - license not expired + quota available
  isSuspended: boolean;
  suspensionReason?: SuspensionReasons;
  liProjectType: LinkedinProjectTypes;
  sessionCookie?: string;
  liAtCookie?: string;
  seatCookie?: string;
}

export interface Results {
  assessment: Assessment;
  significance: {
    significant: boolean;
    requiredTexts: {
      min: number;
      max: number;
    };
  };
  profile?: ProfileValues;
}

export enum SuspensionReasons {
  COOKIES_INVALID = 'cookies are invalid',
}

export interface CookieError {
  message?: CookieErrors;
  cookie?: string;
}

export enum CookieErrors {
  EXPIRED = 'expired',
  SIGNED_OUT = 'signed-out',
  HOUR_LIMIT = '24-hour-limit',
  HOUR_LIMIT_SEARCH = '24-hour-search-limit',
  INVALID_COOKIES = 'invalid-cookies',
}

export enum Attributes {
  FIRST_NAME = 'firstname',
  LAST_NAME = 'lastname',
  COMPANY = 'companyName',
  TYPE = 'type',
}

export const personas = [
  'The Adventurer',
  'The Balanced',
  'The Caretaker',
  'The Conscious',
  'The Decider',
  'The Leader',
  'The Motivator',
  'The Networker',
  'The Optimist',
  'The Performer',
  'The Professional',
  'The Solid',
  'The Teamplayer',
  'The Winner',
];

export enum AnalysisStatus {
  NOT_CONNECTED = 'not-connected',
  PENDING = 'pending',
  SUSPENDED = 'suspended',
  DONE = 'done',
  EXPIRED = 'expired',
}
